import { ComponentProps, PropsWithChildren } from 'react';
import {
  Tooltip,
  TooltipContent,
  TooltipHeader,
  TooltipText,
  TooltipTrigger,
} from '@bridebook/aura';

type Props = {
  header?: string;
  text: string;
  variant?: ComponentProps<typeof Tooltip>['variant'];
  tooltipContentProps?: ComponentProps<typeof TooltipContent>;
} & ComponentProps<typeof TooltipTrigger>;

export const SimpleTooltip = ({
  header,
  text,
  variant = 'dark',
  children,
  tooltipContentProps,
  ...props
}: PropsWithChildren<Props>) => (
  <Tooltip variant={variant}>
    <TooltipTrigger {...props}>{children}</TooltipTrigger>
    <TooltipContent {...tooltipContentProps}>
      {header && <TooltipHeader>{header}</TooltipHeader>}
      {text && <TooltipText>{text}</TooltipText>}
    </TooltipContent>
  </Tooltip>
);
